import {Button, Grid, H3, Modal, Switch, Text} from "@bigcommerce/big-design";
import {Divider} from "@mui/material";
import {useState} from "react";
import {activateClient, deactivateClient} from "../api/clients";

const SettingsModal = (props) => {
    const [pluginStatus, setPluginStatus] = useState(true);

    const closeModal = () => {
        props.setIsOpen(false);
    }
    const handlePluginStatusChange = async (event) => {
        props.setLoading(true);
        const checked = event.target.checked;
        // Activate/Deactivate store
        if (checked)
            await activateClient(props.clientID);
        else
            await deactivateClient(props.clientID);
        // Update toggle switch
        setPluginStatus(checked);
        // Change store settings object
        const storeSettings = props.storeSettings;
        storeSettings.is_valid = checked;
        props.setStoreSettings(storeSettings);
        props.setLoading(false);
    }
    const downloadProductMapping = async () => {
        //TODO: Download product mapping JSON file

    }

    return (
        <>
            <Modal
                variant="dialog"
                actions={[
                    {
                        text: 'Close',
                        variant: 'secondary',
                        onClick: closeModal,
                    },
                    /*{text: 'Save', onClick: closeModal},*/
                ]}
                closeOnClickOutside={false}
                closeOnEscKey={true}
                header="Settings"
                isOpen={props.isOpen}
                onClose={closeModal}
            >
                <Divider style={{marginBottom: "1.5rem"}}/>
                <Grid gridColumns="5fr 1fr" marginLeft="small">
                    <div>
                        <H3>Activate Plugin on your Store</H3>
                        <Text>This will automatically control the visibility of your products</Text>
                    </div>
                    <div style={{alignContent: "center", justifySelf: "right", marginRight: "1.5rem"}}>
                        <Switch checked={pluginStatus} onChange={handlePluginStatusChange}/>
                    </div>
                    <div>
                        <H3 marginBottom="0px">Export your data on Smart Variations</H3>
                        <Text>All of your plugin data will be exported in JSON format</Text>
                    </div>
                    <Button margin="xxSmall" actionType="normal" variant="subtle" onClick={downloadProductMapping}>
                        Export Data
                    </Button>
                </Grid>
            </Modal>
        </>
    );
}

export default SettingsModal;